import React from 'react';

interface SelectProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  children: React.ReactNode;
  className?: string;
}

const Select: React.FC<SelectProps> = ({
  value,
  onChange,
  children,
  className = ''
}) => {
  const baseClasses = 'px-3 py-3 bg-white border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-base transition-all';
  
  return (
    <select
      value={value}
      onChange={onChange}
      className={`${baseClasses} ${className}`}
    >
      {children}
    </select>
  );
};

export default Select;